import { DataGridSettingsAddInData } from "@/models/DataGridSettingsAddInData";
import { DiagnosticView, ViewPageType } from "@/models/DiagnosticView";
import { Preset } from "@/models/Preset";

const TEMPLATE_PREFIX = "template-";

export function parseTemplateName(templateId: string, presetDescription: string): string {
  const withoutPrefix = templateId.startsWith(TEMPLATE_PREFIX)
    ? templateId.slice(TEMPLATE_PREFIX.length)
    : templateId;
  const expectedPrefix = `${presetDescription}-`;
  return withoutPrefix.startsWith(expectedPrefix)
    ? withoutPrefix.slice(expectedPrefix.length)
    : withoutPrefix;
}

export interface DiagnosticsToViewInput {
  preset: Preset;
  template: DataGridSettingsAddInData | null;
  pageTypes: ViewPageType[];
}

export function diagnosticsToView({
  preset,
  template,
  pageTypes,
}: DiagnosticsToViewInput): DiagnosticView {
  const presetDesc = preset.description ?? "Untitled";
  const name = template
    ? `${presetDesc} — ${parseTemplateName(template.id, presetDesc)}`
    : presetDesc;

  return {
    id: crypto.randomUUID(),
    name,
    pageTypes,
    groups: preset.groups ?? [],
    columns: preset.columns.map(c => ({
      diagnosticId: c.diagnostic.id,
      diagnosticName: c.diagnostic.name ?? "",
    })),
    gridState: template?.dataGridState ? template.dataGridState : "{}",
    settings: {
      precisions: template?.precisions ?? {},
      colorIntervals: template?.colorIntervals ?? {},
      columnNames: template?.columnNames ?? {},
      hideOldData: template?.hideOldData ?? false,
      includeDismissedWarnings: template?.includeDismissedWarnings ?? false,
      deviceCountLimit: template?.deviceCountLimit ?? 1000,
      loadAddresses: template?.loadAddresses ?? true,
      chargeRateOnlyWhenCharging: template?.chargeRateOnlyWhenCharging ?? false,
      showArchivedVehicles: template?.showArchivedVehicles ?? false,
      alertRules: template?.alertRules ?? [],
      alertDisplayMode: template?.alertDisplayMode ?? "subtle",
      alertAutoDismiss: template?.alertAutoDismiss ?? true,
    },
    migratedFrom: {
      presetId: preset.id,
      ...(template ? { templateId: template.id } : {}),
    },
    updatedAt: Date.now(),
    updatedBy: "migration",
  };
}
